export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface TaskManagerSortFilterType {
  sortOption: SortFilterOption<server.dto.TaskManagerSort>
}

export const DefaultTaskManagerSortFilter: server.dto.TaskManagerSort = "dateAsc"

export const TaskManagerSortOptions: Array<SortFilterOption<server.dto.TaskManagerSort>> = [
  {
    label: `${RESX.DateTime.lblDate} ${RESX.GeneralLabels.Ascending}`,
    value: "dateAsc",
    enabled: true
  }, {
    label: `${RESX.DateTime.lblDate} ${RESX.GeneralLabels.Descending}`,
    value: "dateDesc",
    enabled: true
  },
];

export const getSortOption = (value: server.dto.TaskManagerSort) => {
  return TaskManagerSortOptions.find(s => s.value === value);
};

export const initialTaskManagerSortFilter: TaskManagerSortFilterType = {
  sortOption: getSortOption(DefaultTaskManagerSortFilter)
};
